import axios from "axios";
import {getJwt} from "../utils/tokenUtils";

export const getEvents = (page, sortBy, sortField) => {
    return axios.get(`/api/admin/events?pageNumber=${page}&sortBy=${sortBy}&sortField=${sortField}`, { headers: {Authorization: 'Bearer ' + getJwt()}});
}
